import { render, staticRenderFns } from "./product-info-detail.vue?vue&type=template&id=34e96df3&scoped=true&"
import script from "./product-info-detail.vue.ts?vue&type=script&lang=ts&"
export * from "./product-info-detail.vue.ts?vue&type=script&lang=ts&"
import style0 from "./product-info-detail.vue?vue&type=style&index=0&id=34e96df3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e96df3",
  null
  
)

export default component.exports